import React = require('react');
import {EditItemComp} from '../EditItemComp';

interface IProfileEditProps {
    userId:number
}

interface IProfileEditState {
}

export default class ProfileEdit extends React.Component<IProfileEditProps, IProfileEditState>{

    constructor(props:IProfileEditProps){
        super(props);
    }

    render() {
        return (
            <div className="body">
                <EditItemComp registrationMode={false} id={ this.props.userId } profileMode={true}/>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/proifle/ProfileEdit.tsx